import SceneManager from './scene-manager';

export default ( containerElement, bacteria ) => {

    const canvas = createCanvas(document, containerElement);
    const sceneManager = new SceneManager(canvas,bacteria);

    let canvasXPosOnScreen;
    let canvasYPosOnScreen;

    bindEventListeners();
    render();

    function createCanvas(document,containerElement) {
        const canvas = document.createElement('canvas');
        containerElement.appendChild(canvas);
        return canvas;
    }

    function bindEventListeners() {
        window.onresize = resizeCanvas;
        resizeCanvas();
    }

    function resizeCanvas() {
        let canvasBounding = canvas.getBoundingClientRect();

        canvas.style.width = '100%';
        canvas.style.height = '100%';

        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        canvasXPosOnScreen = Math.round(canvasBounding.left);
        canvasYPosOnScreen = Math.round(canvasBounding.top);

        sceneManager.onWindowResize();
    }

    function clickLocator(clientX, clientY) {
        // Translate the mouse clicks to coordinates of 3d space.
        // First get position relative to canvas element.
        const canvasX = (clientX - canvasXPosOnScreen);
        const canvasY = (clientY - canvasYPosOnScreen);

        // Now convert to coordinates of the 3d space.
        const threeX = (canvasX / canvas.width) * 2 - 1;
        const threeY = -(canvasY / canvas.height) * 2 + 1;

        // Send these values to the scene.
        return sceneManager.onClick(threeX,threeY);
    }

    function moveCameraTo(feature) {
        sceneManager.moveCameraTo(feature);
    }

    function getFeaturePosition(feature) {
        let pos = sceneManager.getObjectPosition( feature );
        const dpr = window.devicePixelRatio || 1;

        return {
            x: pos.x / dpr,
            y: pos.y / dpr
        }
    }

    function render() {
        requestAnimationFrame(render);
        sceneManager.update();
    }

    return {
        render,
        clickLocator,
        moveCameraTo,
        getFeaturePosition
    };
}



// WEBPACK FOOTER //
// ./src/threejs/three-entry-point.js